/* eslint-disable */
import moment from 'moment';
import { languageOptions } from 'te-components';

/**
 * CRA excludes moment's locale files because they are too large.
 * This function will lazy load the required locale for non en-US locales.
 * For more info, read here: https://create-react-app.dev/docs/troubleshooting/#momentjs-locales-are-missing
 */
export const updateMomentLocale = (locale = 'en-US') => {
  const code = locale.toLowerCase();
  let localeObj = languageOptions.find((obj) => obj.code === locale);
  let nearestMatch = false;

  if (!localeObj) {
    if (locale.includes('-')) {
      locale = locale.split('-')[0];
    }
    localeObj = languageOptions.find((obj) => obj.code.includes(locale));

    if (!localeObj) {
      localeObj = languageOptions.find((obj) => obj.code === 'en-US');
    }

    nearestMatch = true;
  }

  import(`moment/locale/${localeObj.dateLocaleCode}.js`)
    .then(() => moment.locale(code))
    .catch((error) => {
      console.error('Error loading locale:', error);
      moment.locale('en-us');
    });

  document.documentElement.lang = localeObj.code;

  return {
    languageSetToNearestMatch: nearestMatch,
    languageSetTo: localeObj.language,
    languageCode: localeObj.code,
  };
};
